import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const SignOutSvg = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 25 25' fill='none'>
    <path
      d='M9.95312 3.44531H5.95312C5.42269 3.44531 4.91398 3.65603 4.53891 4.0311C4.16384 4.40617 3.95312 4.91488 3.95312 5.44531V19.4453C3.95312 19.9757 4.16384 20.4845 4.53891 20.8595C4.91398 21.2346 5.42269 21.4453 5.95312 21.4453H9.95312'
      stroke='url(#paint0_linear_9757_9300)'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M14.9531 17.4453L9.95312 12.4453L14.9531 7.44531'
      stroke='url(#paint1_linear_9757_9300)'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.95312 12.4453H21.9531'
      stroke='url(#paint2_linear_9757_9300)'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_9757_9300'
        x1='9.95313'
        y1='3.44531'
        x2='3.72525'
        y2='3.5245'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_9757_9300'
        x1='14.9531'
        y1='7.44531'
        x2='9.76428'
        y2='7.54428'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_9757_9300'
        x1='21.9531'
        y1='12.4453'
        x2='11.6536'
        y2='17.1601'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
    </defs>
  </svg>
);

export const SignOutColorIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={SignOutSvg} {...props} />
);
